<script>
export default {
  name: "newPermissionIcon",
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M6.99344 1.48667L3.66677 2.74C2.9001 3.02667 2.27344 3.93333 2.27344 4.74666V9.7C2.27344 10.4867 2.79344 11.52 3.42677 11.9933L6.29344 14.1333C7.23344 14.84 8.7801 14.84 9.7201 14.1333L12.5868 11.9933C13.2201 11.52 13.7401 10.4867 13.7401 9.7V4.74666C13.7401 3.92666 13.1134 3.02 12.3468 2.73333L9.0201 1.48667C8.45344 1.28 7.54677 1.28 6.99344 1.48667Z"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.0332 7.91333L7.10654 8.98666L9.9732 6.12"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped></style>
